module.exports = __webpack_public_path__ + "img/DieWand.59f46292.jpg";